module.exports = __webpack_public_path__ + "img/c03_buildingtechtemper_Normal_ua.0f051b01.webp";